const QUOTES = [
  {
    quote:
      "Tenía un piso heredado en el Centro y me daba miedo alquilarlo después de una mala experiencia. Conocí a THE NEXT ROOM en Zaragoza, son de aquí, los visité en persona y me transmitieron mucha confianza. Llevo meses cobrando puntual sin mover un dedo.",
    name: "María R.",
    role: "Propietaria · Zaragoza · Centro",
  },
  {
    quote:
      "Mi piso de Delicias estaba bastante anticuado y no quería meterme en una reforma con el riesgo que conlleva. THE NEXT ROOM se hizo cargo de todo, ahora luce como nuevo y yo cobro más de lo que me ofrecía cualquier inmobiliaria tradicional.",
    name: "José Luis P.",
    role: "Propietario · Zaragoza · Delicias",
  },
  {
    quote:
      "Lo que más valoro es que son zaragozanos como yo. Si hay cualquier incidencia llaman, se acercan al piso y la resuelven en horas. Es algo que con una gestora grande de fuera no había tenido nunca.",
    name: "Carmen S.",
    role: "Propietaria · Zaragoza · Universidad",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="nr-section">
      <div className="nr-container">
        <div className="max-w-2xl mb-14">
          <span className="nr-eyebrow">Testimonios</span>
          <h2 className="nr-h2 mt-4">
            Propietarios reales que ya duermen tranquilos.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {QUOTES.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="nr-card flex flex-col"
            >
              <div className="text-[42px] leading-none text-[#43A4A8] font-display">
                “
              </div>
              <blockquote className="mt-2 text-[15px] leading-relaxed text-[#111]">
                {t.quote}
              </blockquote>
              <figcaption className="mt-7 pt-6 border-t border-[#EAEAEA]">
                <div className="font-sub text-[14px] text-[#111]">
                  {t.name}
                </div>
                <div className="text-[12px] nr-text-soft mt-0.5">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
